export const STATUS_SCREEN_TEXT = {
  traceId: '문의할 때 알려 주세요',
} as const;
